__turbopack_context__.v({
  "dataStream": "VerticalRays-module__FZcEKG__dataStream",
  "dataStreamCenter": "VerticalRays-module__FZcEKG__dataStreamCenter",
  "dataStreamLeft": "VerticalRays-module__FZcEKG__dataStreamLeft",
  "dataStreamRight": "VerticalRays-module__FZcEKG__dataStreamRight",
  "dataStreamSecondaryLeft": "VerticalRays-module__FZcEKG__dataStreamSecondaryLeft",
  "dataStreamSecondaryRight": "VerticalRays-module__FZcEKG__dataStreamSecondaryRight",
  "streamFlow": "VerticalRays-module__FZcEKG__streamFlow",
  "verticalRays": "VerticalRays-module__FZcEKG__verticalRays",
});
